import React from 'react'

function PasswordPlolicy() {
  return (
    <div>PasswordPlolicy</div>
  )
}

export default PasswordPlolicy